import { render } from "./GeneralSpecsCreating.vue?vue&type=template&id=45a15f04&ts=true"
import script from "./GeneralSpecsCreating.vue?vue&type=script&lang=ts"
export * from "./GeneralSpecsCreating.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__